import { InvoiceSchema, ObjectIdSchema, RevisionedLineItemSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const DynamicInvoicePageRevisionedLineItemSchema = RevisionedLineItemSchema.pick({ 
  id: true,
  name: true,
  price: true,
  type: true,
  description: true,
  percentage: true,
});

export type DynamicInvoicePageRevisionedLineItem = oz.infer<typeof DynamicInvoicePageRevisionedLineItemSchema>;

export const DynamicInvoicePageInvoiceSchema = InvoiceSchema.pick({
  id: true,
  name: true,
  reviewStatus: true,
  billingCycle: true,
  lineItems: true,
  purchaseOrder: true,
  notes: true,
  approvedAt: true,
  revenueBreakdown: true,
  taxRate: true,
  syncStatus: true,
}).extend({
  revisionedLineItems: oz.array(DynamicInvoicePageRevisionedLineItemSchema),
  contractId: ObjectIdSchema.optional(),
  contractName: oz.string().optional(),
});

export type DynamicInvoicePageInvoice = oz.infer<typeof DynamicInvoicePageInvoiceSchema>;